'use client';

import { useState, createContext } from 'react';

import Contentlet from '@/components/shared/contentlet';

import { FooterBlockNodes } from './BlockNodes';
import { DotBlockEditor } from '@/components/shared/decodeTextBlock';

/**
 * Handle the active section state in the footer link section
 * The context is needed to have a reference to the active section on the BlockNodes components
 *
 *  @type {*} */
export const ActiveSectionContext = createContext();

/**
 * LinkSection component
 *
 * @description This component is responsible for rendering the footer links section
 * @param {{ contentlet?: object }} props - The footer contentlet fetched by the Footer
 * @return {*}
 */
export const LinkSection = ({ contentlet }) => {
    const [activeSection, setActiveSection] = useState(null);

    return (
        <ActiveSectionContext.Provider value={{ activeSection, setActiveSection }}>
            {contentlet?.body && (
                <Contentlet contentlet={contentlet}>
                    <DotBlockEditor
                        className="md:footer-links-container relative flex w-full flex-col"
                        blocks={contentlet.body}
                        customRenderers={FooterBlockNodes}
                    />
                </Contentlet>
            )}
        </ActiveSectionContext.Provider>
    );
};
